import LockIcon from '@mui/icons-material/Lock';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '~/components/Button/Button';
import Card from '~/components/Card/Card';
import { HeaderSummarySectionComponent } from '~/components/HeaderSummarySection/HeaderSummarySection.component';
import Loader from '~/components/Loader/Loader';
import { GetPaymentResponse } from '~/entities/responses/getPaymentResponse';
import { DataTransacton } from '~/entities/schemas/dataTransaction';
import { formatNumber } from '~/utils/number';

import styles from './OrderSummaryCard.module.scss';
import { OrderSummaryItemComponent } from './OrderSummaryItem.component';

interface OrderSummaryCardComponentProps {
  paymentInfos?: GetPaymentResponse;
  loading?: boolean;
  phoneNumber: string;
  isMobile: boolean;
  dialCode: string;
  // paymentType
  dataTransaction: DataTransacton | null;
  loadingDataTr: boolean;
  actionDisable: boolean;
  actionLoading: boolean;
}

export const OrderSummaryCardComponent: React.FC<OrderSummaryCardComponentProps> = ({
  paymentInfos,
  loading,
  phoneNumber,
  isMobile = false,
  dialCode,
  dataTransaction,
  loadingDataTr,
  actionDisable,
  actionLoading,
}) => {
  const { t, i18n } = useTranslation();
  // console.log(dataTransaction?.returnUrl, 'dataTransaction YYY');

  const handleGetTitle = useCallback((data: DataTransacton | null): string => {
    if (data !== null && data.application !== null && data.application.merchant !== null) {
      return data.application.merchant.name;
    }
    return 'eVisa for Cameroon';
  }, []);

  return (
    <Card slightlyRounded className={styles.card_wrapper}>
      {loadingDataTr ? (
        <Loader />
      ) : (
        <HeaderSummarySectionComponent
          title={handleGetTitle(dataTransaction)}
          subTitle={`${formatNumber(
            (Number(paymentInfos?.data?.amount) || 0) + (Number(paymentInfos?.data?.fees) || 0),
            i18n.language ?? 'fr',
          )} ${paymentInfos?.data.currency}`}
          logo={dataTransaction?.application?.merchant?.logoUrl ?? ''}
        />
      )}
      <hr />
      <OrderSummaryItemComponent
        title={t('home:header:netAmount')}
        value={`${formatNumber(paymentInfos?.data.amount ?? 0, i18n.language ?? 'fr', 4)} ${
          paymentInfos?.data.currency
        }`}
      />
      <OrderSummaryItemComponent
        title={t('home:header:fees')}
        value={`${formatNumber(paymentInfos?.data.fees ?? 0, i18n.language ?? 'fr')} ${paymentInfos?.data.currency}`}
      />
      <OrderSummaryItemComponent
        title={t('home:header:grossAmountTotal')}
        value={`${formatNumber(Number(paymentInfos?.data?.totalAmount) || 0, i18n.language ?? 'fr')} ${
          paymentInfos?.data.currency
        }`}
      />
      <OrderSummaryItemComponent
        title={t('successPage:amountLocalCurrency')}
        value={`${formatNumber(paymentInfos?.data.convertedTotalAmount ?? 0, i18n.language ?? 'fr')} ${
          paymentInfos?.data.convertedCurrency
        }`}
      />
      <hr />

      {actionDisable === false && (
        <>
          <Button
            title={t('orderSummary:pay')}
            size="block"
            rounded
            type="submit"
            className={styles.submit_buttonGreen}
            loading={loading}
            disabled={loading || (isMobile && dialCode.length === 0)}
          />
        </>
      )}
      {actionDisable === true && (
        <Button
          title={t('orderSummary:pay')}
          size="block"
          rounded
          type="submit"
          className={styles.submit_buttonGreen}
          loading={actionLoading}
          disabled={true}
        />
      )}
      {dataTransaction?.returnUrl !== '' &&
        dataTransaction?.returnUrl !== undefined &&
        dataTransaction?.returnUrl !== null && (
          <Button
            title={t('orderSummary:cancel')}
            size="block"
            rounded
            type="button"
            onClick={() => {
              window.location.replace(dataTransaction?.returnUrl ?? '');
              // window.location.href = dataTransaction?.returnUrl ?? '';
            }}
            className={styles.cancelButton}
            disabled={false}
          />
        )}

      <div className={styles.footer}>
        <LockIcon />
        {t('home:footer:securedBy')}
      </div>
    </Card>
  );
};
